import PropTypes from "prop-types"
import React from "react"
import { Container } from "reactstrap"

//i18n
import { withTranslation } from "react-i18next"
import PendingOrders from "../Orders/PendingOrders"

const Dashboard = props => {
  //meta title
  document.title = "Dashboard"

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <PendingOrders/>
        </Container>
      </div>
    </React.Fragment>
  )
}

Dashboard.propTypes = {
  t: PropTypes.any,
  chartsData: PropTypes.any,
  onGetChartsData: PropTypes.func,
}

export default withTranslation()(Dashboard)
